export const COMMERCIAL_AGREEMENT_EDIT_PARAM = {
  commercialAgreementId: 'commercialAgreementId',
}
